import { render, staticRenderFns } from "./HeritageDetail.vue?vue&type=template&id=22f44912&"
import script from "./HeritageDetail.vue?vue&type=script&lang=js&"
export * from "./HeritageDetail.vue?vue&type=script&lang=js&"
import style0 from "./HeritageDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports